import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {DOCUMENT, DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {HasSubscriptions} from '../../has-subscriptions';
import {AbstractControl, FormArray, FormControl, FormGroup, ValidatorFn, Validators} from '@angular/forms'; // kanew
import {emailRegex, LeadTrigger, RemaxLeadEntity, LeadType} from '../../../classes/leads';
import {TranslateService} from '@ngx-translate/core';
import {debounceTime, filter, switchMap} from 'rxjs/operators';
import {AnalyticsService} from '../../../services/analytics/analytics.service';
import {HOME_ESTIMATOR_CONSULT_AN_AGENT, SITE_SEARCH, SITE_SEARCH_TERM} from '../../../classes/analytics-tags';
import {GoogleMapsService} from '../../../services/google-maps.service';
import {PreferencesService} from '../../../services/preferences.service';
import {Observable} from 'rxjs';
import {SearchResult} from '../../search-bar/search-bar.component';
import {Angulartics2} from 'angulartics2';
import {DisplayError, ErrorKey, ErrorService} from '../../../services/error.service';
import {LeadsService} from '../../../services/leads.service';
import {HttpErrorResponse} from '@angular/common/http';
import {DomManipulationService} from '../../../services/dom-manipulation/dom-manipulation.service';
import {RECAPTCHA_SCRIPT} from '../../../classes/dynamicScripts';
import LatLngLiteral = google.maps.LatLngLiteral;
import {forEach, update} from 'lodash-es';
import {isNullOrUndefined, log} from 'util';
import {isDefined} from '@ngx-translate/core/lib/util';

@Component({
  selector: 'app-home-estimator-lead-form',
  templateUrl: './home-estimator-lead-form.component.html',
  styleUrls: ['./home-estimator-lead-form.component.scss']
})

export class HomeEstimatorLeadFormComponent extends HasSubscriptions implements OnInit {
  videoUrl: SafeResourceUrl;
  homeEstimatorForm: FormGroup;
  locationResults: SearchResult[] = [];
  showAdditionalActionsButtons: boolean = false;
  showSearchResults: boolean = false;
  focus: boolean = false;
  @ViewChild('addressBarRef') addressBarRef: ElementRef;
  @Input() email: string;
  @Input() showRequestSent: boolean = false;
  userLat: number;
  userLng: number;
  address: string;
  postalCode: string;
  city: string;
  province: string;
  isSearching = false;
  locationLatLng: LatLngLiteral;
  recentSearches: SearchResult[] = [];
  leadInfo: Partial<RemaxLeadEntity>;
  recaptchaId: number;
  newSet: string[] = [];
  private _radiusForSearchBias: number = 50000; // in meters
  private _maxLocationResults = 3;


  @Output() showRequestSentEvent: EventEmitter<any> = new EventEmitter();

  constructor(
    @Inject(DOCUMENT) private document,
    private sanitizer: DomSanitizer,
    private analyticsService: AnalyticsService,
    private preferencesService: PreferencesService,
    private domManipulationService: DomManipulationService,
    private googleService: GoogleMapsService,
    private cdRef: ChangeDetectorRef,
    private angulartics2: Angulartics2,
    private errorService: ErrorService,
    private leadsService: LeadsService,
    private translateService: TranslateService
  ) {
    super();
    this.homeEstimatorForm = new FormGroup({
      userName: new FormControl(''),
      userEmail: new FormControl('', {validators: [Validators.required, Validators.pattern(emailRegex)], updateOn: 'change'}),
      userAddress: new FormControl('',  [Validators.required])
    });
  }


  get nameInput(): string {
    return this.homeEstimatorForm.controls.userName.value;
  }

  set nameInput(value: string) {
    this.homeEstimatorForm.controls.userName.setValue(value);
  }

  get emailInput(): string {
    return this.homeEstimatorForm.controls.userEmail.value;
  }

  set emailInput(value: string) {
    this.homeEstimatorForm.controls.userEmail.setValue(value);
  }

  get addressInput(): string {
    return this.homeEstimatorForm.controls.userAddress.value;
  }

  set addressInput(value: string) {
    this.homeEstimatorForm.controls.userAddress.setValue(value);
  }

  ngOnInit() {
    this.setVideoUrl();
    this.watchAddressInput();
    this.watchPositionInfo();
    if (this.email) {
      this.homeEstimatorForm.controls['email'].setValue(this.email);
    }
  }

  setVideoUrl() {
    this.videoUrl =  this.getVideoUrl();
  }

  getVideoUrl(): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/cxdQmZQBu6o?rel=0');
  }

  watchAddressInput() {
    this.addSub(this.homeEstimatorForm.get('userAddress').valueChanges
    .pipe(debounceTime(200))
    .pipe(filter((searchInput: string) => {

      if (!searchInput || !this.locationLatLng) {
        this._resetResults();
        return false;
      }
      return true;
    }))
    .pipe(switchMap((searchInput: string) => this._getQueryPredictionsSearch(searchInput)))
    .subscribe(x => {
      if(x) {
        this.locationResults = x.map((e) => new SearchResult(e.description, e.description, 'location'));
      }
      else{
        this.locationResults = null;
      }
      this.isSearching = false;
      this.cdRef.detectChanges();
    }));
  }

  private _resetResults() {
    this.locationResults = [];
  }

  private _getQueryPredictionsSearch(searchInput: string): Observable<google.maps.places.AutocompletePrediction[]> {
    this.isSearching = true;
    this.analyticsService.eventTrack(SITE_SEARCH, { [SITE_SEARCH_TERM]: searchInput });
    return this.googleService.getPlacePredictions(searchInput, new google.maps.LatLng(this.locationLatLng.lat, this.locationLatLng.lng), this._radiusForSearchBias);
  }

  watchPositionInfo() {
    this.addSub(this.preferencesService.positionInfoChanged.subscribe((position) => {
      if (position.centerLatLng) {
        this.locationLatLng = {
          lat: position.centerLatLng.lat,
          lng: position.centerLatLng.lng
        } as LatLngLiteral;
      }
    }));
  }

  isFormControlValid(control: FormControl) {
    return !(control.invalid && (control.dirty || control.touched));
  }

  get userName() {
    return this.homeEstimatorForm.get('userName');
  }

  get userEmail() {
    return this.homeEstimatorForm.get('userEmail');
  }

  get userAddress() {
    return this.homeEstimatorForm.get('userAddress');
  }

  sendGrecaptcha() {
    this.addSub(
      this.domManipulationService.loadScript(RECAPTCHA_SCRIPT).subscribe(() => {
        grecaptcha.execute(this.recaptchaId);
      })
    );
  }

  onAddressInputClick() {
    this._getQueryPredictions();
    this.showSearchResults = true;
  }

  private _getQueryPredictions() {
    if (!!this.addressInput) {
      this._getQueryPredictionsSearch(this.addressInput);
    }
    else this._resetResults();
  }

  getOnSubmit(): (recaptchaKey: string) => void {
    return this.onSubmit.bind(this);
  }

  onSubmit(recaptchaKey: string) {
    this.googleService.performGeocode(this.addressInput).then(results => {
      if (results[0].address_components.length === 1 || results[0].address_components.findIndex(g => g.short_name.toLowerCase() === 'qc') !== -1) {

        this.homeEstimatorForm.controls['userAddress'].setErrors({'incorrect': true});
        this.homeEstimatorForm.controls['userAddress'].setValue('');
        this.homeEstimatorForm.updateValueAndValidity({onlySelf : true});
        return;
      }

      const address = results[0].address_components;
      this.address = results[0].formatted_address;
      const postalCode = address.find(g => g.types.includes('postal_code'))
      const city = address.find(g => g.types.includes('locality'));
      const province = address.find(g => g.types.includes('administrative_area_level_1'));

      this.postalCode = postalCode ? postalCode.long_name : null;
      this.city = city ? city.long_name : null;
      this.province = province ? province.short_name : null;

      const leadBody = this.constructTheLeadObject();
      this.leadsService.sendLead(leadBody, recaptchaKey)
        .then(() => {
          this.sendAnalyticsEvent();
          this.homeEstimatorForm.reset();
          this.showRequestSentEvent.emit();
        })
        .catch((err: HttpErrorResponse) => {
          this.errorService.displayError(ErrorKey.lead, err.error.errorCode, 30);
        });
      }
    );
  }

  constructTheLeadObject(): RemaxLeadEntity {
    const leadBody: RemaxLeadEntity = {
      leadType: LeadType.HVEGeneric,
      triggerType: LeadTrigger.Generic,
      contactInfo: {
        name: this.nameInput,
        email: this.emailInput,
        postalCode: this.postalCode,
        city: this.city,
        province: this.province,
      },
      contactPref: {
        email: true,
      },
      comments: this.translateService.instant(`contact.home-estimator-form`, {address: this.address})
    };
    return leadBody;
  }
  sendAnalyticsEvent() {
    let tagName = HOME_ESTIMATOR_CONSULT_AN_AGENT;
    this.angulartics2.eventTrack.next({
      properties: {
        event: tagName
      }
    });
  }
  onLoseFocus() {
    setTimeout(() => {
      if (!this.addressBarRef.nativeElement.contains(this.document.activeElement)) this.showSearchResults = false;
      // [MBL-3080] Added the following functionality to check if address autocomplete is selected otherwise clear the input to start fresh...
      if (!isNullOrUndefined(this.locationResults)) {
        Object.entries(this.locationResults).forEach(([key, value]) => this.newSet.push(this.locationResults[key].text.toLowerCase()));

        if (!this.newSet.includes(this.addressInput.toLowerCase())) {
          this.homeEstimatorForm.controls['userAddress'].setErrors({'incorrect': true});
          this.homeEstimatorForm.controls['userAddress'].setValue('');

          this.homeEstimatorForm.updateValueAndValidity({onlySelf : true});
          this.triggerValidation(this.homeEstimatorForm);
        }
        else {
          this.homeEstimatorForm.controls['userAddress'].setErrors({'incorrect': null});
          this.homeEstimatorForm.controls['userAddress'].updateValueAndValidity({onlySelf : true});

          this.homeEstimatorForm.updateValueAndValidity({onlySelf : true});
          this.triggerValidation(this.homeEstimatorForm);

        }
      }
      else {
        this.homeEstimatorForm.controls['userAddress'].setErrors({'incorrect': true});
        this.homeEstimatorForm.controls['userAddress'].setValue('');
        this.homeEstimatorForm.updateValueAndValidity({onlySelf : true});
        this.triggerValidation(this.homeEstimatorForm);
      }

    })


  }

  private triggerValidation(control: AbstractControl) {
    if (control instanceof FormGroup) {
      const group = (control as FormGroup);

      for (const field in group.controls) {
        const c = group.controls[field];

        this.triggerValidation(c);
      }
    }
    else if (control instanceof FormArray) {
      const group = (control as FormArray);

      for (const field in group.controls) {
        const c = group.controls[field];

        this.triggerValidation(c);
      }
    }

    control.updateValueAndValidity({ onlySelf: false });
  }

  onSelectResult($event) {
    this.addressInput = $event.data;
    this.showSearchResults = false;
    this.focus = false;
  }

}


